@if(is_loading){
<div class="ph-item w-full bg-transparent border-none m-0 p-0">
  <div class="ph-col-12 p-0">
    <!-- <div class="ph-row">
      <div class="ph-col-4 h-[24px] rounded-[10px]"></div>
    </div> -->
    <div class="ph-row p-0">
      <div class="ph-col-12 h-[228px] rounded-[10px]"></div>
    </div>
  </div>
</div>
} @else{
<div class="app__itemCard w-full min-h-fit max-h-[300px] justify-start h-fit" [ngClass]="{ 'max-h-full': true }">
  <p class="app__form--attribute--title font-semibold m-0 text-[18px]">
    {{ (currentUser?.nick_name ?? currentUser?.first_name) + "'s" | titlecase }} Premium Keys @if (premiumKeys.length > 0){
    <span class=""> ({{ premiumKeys.length }}) </span>
    }
  </p>

  <div class="overflow-y-auto h-[75%] py-3 my-2 mt-4 pt-0">
    @if (premiumKeys.length > 0) { @for (key of premiumKeys; track key) {
    <div
      [class]="
        key
          ? 'flex items-center gap-2 rounded-lg px-2 p-2 border border-[#ddddd3] font-semibold text-center text-[#515765] hover:bg-light-blue cursor-pointer h-16 w-full text-xs sm:text-sm justify-between my-2 '
          : 'flex items-center gap-2 rounded-lg px-2 p-2 border border-[#ddddd3] font-semibold text-center text-[#515765] bg-[#f3f2f2] cursor-pointer h-16 w-full text-xs sm:text-sm justify-between'
      "
      [matTooltip]="key.keyName"
      matTooltipPosition="above"
    >
      <div class="flex gap-2 items-center h-full">
        <span class="w-[52px] h-[52px] flex items-center justify-center rounded-lg bg-[#EBF0FA]">
          <img src="/assets/images/premium-key-blue.svg" alt="" class="w-6 h-6" />
        </span>
        <div class="flex items-start flex-col">
          <p class="m-0 flex items-center gap-2">{{ key.keyName | truncateStrPipe : 28 | titlecase }}</p>
        </div>
      </div>
      <!-- Commenting this out incase we decide to re add the delete functionality -->
      <!-- <button class="flex items-center justify-center" mat-icon-button [disableRipple]="true">
        <div class="see-more-btn">
          <span class="material-icons horiz" style="position: relative">more_vert</span>
        </div>
      </button> -->
      <!-- <mat-menu #menu="matMenu"> 
             <p mat-menu-item class="delete-key m-0" style="color: #eb5757" (click)="deleteSeuritykey(key)">
               <img src="assets/images/deletIconWeb.svg" class="delete-key-img" />
               Delete
             </p> 
            </mat-menu> -->
    </div>
    } } @else {
    <div
      [class]="
        'flex items-center gap-2 rounded-lg px-2 p-2 border border-[#ddddd3] font-semibold text-center text-[#515765] bg-[#f3f2f2] cursor-pointer h-16 w-full text-xs sm:text-sm justify-between'
      "
      [ngClass]="{ 'h-[46px]': true }"
      matTooltipPosition="above"
    >
      <p class="text-center flex items-center justify-center m-0 w-full text-[#b1acb0] gap-2 font-normal">
        <!-- <span class="material-icons cursor-pointer text-lg material-symbols-outlined" (click)="(null)"> person </span> -->
        <img src="/assets/images/premium-key.svg" alt="" class="w-6 h-6" />
        No Premium Keys to show
      </p>
    </div>
    }
  </div>
  <div class="flex gap-3 items-center justify-between w-full">
    <button class="app__btn--primary p-[10px]" (click)="addNewKey()" [ngClass]="{ 'm-0': true, 'my-2': false }">Add New</button>
  </div>
</div>
}
